import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import axios from "axios";
import store, { persistor } from "./Store/store";
import "./assets/css/bootstrap.min.css";
import "./assets/css/fontawesome.css";
import "./assets/css/line-awesome.min.css";
import "@fullcalendar/daygrid/main.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from "redux-persist/integration/react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import BootLoader from "./Components/Common/BootLoader";
import { resolveApiUrl } from "./utils/apiBase";

// Rewrite mis-baked Bitbucket hosts (sslip.io / IPs / .net↔.com) on every request.
axios.interceptors.request.use((config) => {
  if (config.url) {
    config.url = resolveApiUrl(config.url);
  }
  if (config.baseURL) {
    config.baseURL = resolveApiUrl(config.baseURL);
  }
  return config;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<BootLoader />} persistor={persistor}>
        <App />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
